<template>
  <div element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loading="loading">
    <div v-if="!shju">
      <el-form label-width="90px">
        <!-- <el-form-item label="选择学期：">
        <el-select v-model="value" placeholder="请选择">
          <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id"> </el-option>
        </el-select>
      </el-form-item> -->
        <el-form-item label="选择时间：">
          <el-date-picker v-model="queryTime" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange"
            align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="任务状态：">
          <el-button type="text" :class="status === '' ? '' : 'huihse'"
            @click="; (status = ''), (page = 1), queryReadTaskList()">全部</el-button>
          <el-button type="text" :class="status === 1 ? '' : 'huihse'"
            @click="; (status = 1), (page = 1), queryReadTaskList()">已发布</el-button>
          <el-button type="text" :class="status === 0 ? '' : 'huihse'"
            @click="; (status = 0), (page = 1), queryReadTaskList()">未发布</el-button>
        </el-form-item>
        <el-form-item label="任务类型：">
          <el-button type="text" :class="type === '' ? '' : 'huihse'"
            @click="; (type = ''), (page = 1), queryReadTaskList()">全部</el-button>
          <el-button type="text" :class="type === 1 ? '' : 'huihse'"
            @click="; (type = 1), (page = 1), queryReadTaskList()">必读</el-button>
          <el-button type="text" :class="type === 2 ? '' : 'huihse'"
            @click="; (type = 2), (page = 1), queryReadTaskList()">推荐</el-button>
        </el-form-item>
        <div class="spb">
          <div>
            <el-input size="small" style="width: 250px" v-model="input" placeholder="请输入任务名称"
              @keyup.enter.native="; (page = 1), queryReadTaskList()"></el-input>
            <el-button type="primary" @click="; (page = 1), queryReadTaskList()" size="small">搜索</el-button>
          </div>
          <div>
            <el-button type="primary" @click="dialogVisible = true" size="small">+ 添加</el-button>
          </div>
        </div>
      </el-form>

      <el-table :data="tableData" stripe border style="width: 100%; margin-top: 15px">
        <el-table-column type="index" width="50" align="center"></el-table-column>
        <el-table-column prop="taskName" label="任务名称" align="center"> </el-table-column>
        <el-table-column prop="submitLevel" label="任务范围" align="center">
          <template slot-scope="scope">
            <!-- <el-popover placement="top" width="200" trigger="hover"> -->
            <div>
              <span v-for="(item, index) in scope.row.readTaskScopeList" :key="item.id">{{ item.gradeName }}{{
                item.className }}{{ index != scope.row.readTaskScopeList.length - 1 ? '、' : '' }}</span>
            </div>
            <!-- <el-button type="text" slot="reference">查看</el-button> -->
            <!-- </el-popover> -->
          </template>
        </el-table-column>
        <el-table-column prop="taskType" label="任务类型" align="center">
          <template slot-scope="scope">
            {{ scope.row.taskType == 1 ? '必读' : '推荐' }}
          </template>
        </el-table-column>
        <el-table-column prop="taskType" label="任务进度(人数)在读/已读/已测" align="center">
          <template slot-scope="scope"> {{ scope.row.readingNumber }}/{{ scope.row.completeNumber }}/{{
            scope.row.paperNumber }} </template>
        </el-table-column>
        <el-table-column prop="creatorName" label="发布人" align="center"> </el-table-column>
        <el-table-column prop="createTime" label="操作时间" align="center"> </el-table-column>
        <el-table-column prop="publishStatus" label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.publishStatus == 1 ? '已发布' : '未发布' }}
          </template>
        </el-table-column>
        <el-table-column prop="submitLevel" label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="getDetail(scope.row)">任务详情</el-button>
            <el-button type="text" @click="wancheng(scope.row)">完成详情</el-button>
            <el-button type="text" @click="edit(scope.row)" v-if="scope.row.publishStatus == 0">编辑</el-button>
            <el-button type="text" @click="publish(scope.row)" v-if="scope.row.publishStatus == 0">发布</el-button>
            <el-button type="text" @click="deleteItem(scope.row)" v-if="scope.row.publishStatus == 0">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="teuhjofa" :current-page.sync="page" @prev-click="gai" @next-click="gai"
        @current-change="gai" :hide-on-single-page="true" background :page-size="10" layout="total,prev, pager, next"
        style="margin-top: 15px" :total="total"></el-pagination>
    </div>
    <el-dialog :append-to-body="true" :title="ruleForm.id == '' ? '新增任务' : '编辑任务'" :before-close="addClose"
      :visible.sync="dialogVisible" width="60%" style="text-align: left">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="任务名称：" prop="taskName">
          <el-input size="small" style="width: 250px" v-model="ruleForm.taskName" placeholder="请输入任务名称"></el-input>
        </el-form-item>
        <el-form-item label="任务类型：" prop="taskType">
          <el-radio-group v-model="ruleForm.taskType">
            <el-radio v-for="item in taskTypeList" :key="item.code" :label="Number(item.code)">{{ item.name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="任务范围：" prop="classesIdList">
          <span v-if="ruleForm.classesIdList.length == 0">暂未选择班级</span>
          <span v-for="(item, index) in ruleForm.classesIdList" :key="item.id">{{ item.name }}{{ index !=
            ruleForm.classesIdList.length - 1 ? '、' : '' }}</span>
          <el-button type="text" @click="selectTree()">选择范围</el-button>
        </el-form-item>
        <el-form-item label="任务内容：" prop="taskCatalogue">
          <el-radio-group v-model="ruleForm.taskCatalogue">
            <el-radio v-for="item in taskCatalogueList" :key="item.code" :label="Number(item.code)">{{ item.name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <div style="margin-bottom: 10px">
          <el-button type="primary" @click="selectBook" v-if="ruleForm.taskCatalogue == 2" size="small">选择图书</el-button>
          <el-button type="primary" @click="selectBill" v-if="ruleForm.taskCatalogue == 1" size="small">选择系列</el-button>
        </div>
        <!-- 单本书 -->
        <el-table :data="ruleForm.bookIdList" border stripe style="width: 100%" highlight-current-row
          v-if="ruleForm.taskCatalogue == 2">
          <el-table-column label="封面" align="center" width="130">
            <template slot-scope="scope">
              <el-image style="width: 100px; height: 100px"
                :src="scope.row.bookImgUrl ? scope.row.serverHttp + scope.row.bookImgUrl : ''" fit="cover">
                <div slot="error" class="image-err">暂无封面</div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="bookName" label="名称" align="center"></el-table-column>
          <el-table-column prop="bookGradesName" label="适合年级" align="center"></el-table-column>
          <el-table-column prop="bookStarNumber" label="阅读分级（星星值）" align="center"></el-table-column>
          <el-table-column prop="bookAuthor" label="作者" align="center"> </el-table-column>
          <el-table-column prop="publishingName" label="出版社" align="center"></el-table-column>
          <el-table-column prop="bookCode" label="编号" align="center"></el-table-column>
        </el-table>
        <!-- 系列 -->
        <el-table :data="ruleForm.billIdList" border stripe style="width: 100%" highlight-current-row
          v-if="ruleForm.taskCatalogue == 1">
          <el-table-column label="封面" align="center" width="130">
            <template slot-scope="scope">
              <el-image style="width: 100px; height: 100px"
                :src="scope.row.imgUrl ? scope.row.serverHttp + scope.row.imgUrl : ''" fit="cover">
                <div slot="error" class="image-err">暂无封面</div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="billName" label="名称" align="center"></el-table-column>
          <el-table-column prop="billGradesName" label="适合年级" align="center"></el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="
          dialogVisible = false
        resetForm()
          " size="small">取 消</el-button>
        <el-button type="primary" @click="submitRuleForm" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :append-to-body="true" title="选择范围" :visible.sync="dialogVisible1" width="40%" style="text-align: left">
      <div>
        <el-tree :data="gradeList" ref="tree" show-checkbox default-expand-all node-key="classId" highlight-current
          :props="defaultProps" @check="handleCheckChange"></el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submitGrade" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :append-to-body="true" title="选择图书" :visible.sync="dialogVisible2" width="60%" style="text-align: left"
      :before-close="bookClose">
      <div element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loading="loading1">
        <el-form label-width="80px">
          <el-form-item label="适合年级:">
            <el-button type="text" @click="
              pageNum = 1
            gradeId = ''
            taskQueryList()
              " :class="gradeId == '' ? '' : 'yanse'">全部</el-button>
            <el-button type="text" @click="
              pageNum = 1
            gradeId = item.gradeId
            taskQueryList()
              " :class="item.gradeId == gradeId ? '' : 'yanse'" v-for="item in gradeList" :key="item.gradeId">{{
              item.name }}</el-button>
          </el-form-item>
          <el-form-item label="所属专栏:">
            <el-button type="text" @click="
              pageNum = 1
            specialId = ''
            taskQueryList()
              " :class="specialId == '' ? '' : 'yanse'">全部</el-button>
            <el-button type="text" @click="
              pageNum = 1
            specialId = item.code
            taskQueryList()
              " :class="item.code == specialId ? '' : 'yanse'" v-for="item in specialColumnList" :key="item.code">{{
              item.name }}</el-button>
          </el-form-item>
        </el-form>
        <div style="margin-bottom: 10px">
          <el-cascader clearable v-model="classifyId" @change="
            pageNum = 1
          taskQueryList()
            " placeholder="请选择图书所属分类" :options="options1" :show-all-levels="false" size="small"></el-cascader>
          <el-select v-model="bookLevel" @change="
            pageNum = 1
          taskQueryList()
            " placeholder="请选择图书等级" clearable size="small">
            <el-option v-for="item in bookLevelList" :key="item.id" :label="item.name" :value="item.code"> </el-option>
          </el-select>
          <el-input size="small" style="width: 250px" v-model="queryBookName" placeholder="请输入书籍名称" @keyup.enter.native="
            pageNum = 1
          taskQueryList()
            "></el-input>
          <el-button type="primary" @click="
            pageNum = 1
          taskQueryList()
            " size="small">搜索</el-button>
        </div>
        <div>
          <el-button type="text" :class="!isSchool ? '' : 'huihse'" @click="switchBooks(false)">平台书库</el-button>
          <el-button type="text" :class="isSchool ? '' : 'huihse'" @click="switchBooks(true)">校本书库</el-button>
        </div>
        <el-table :data="bookList" ref="singleTable" border stripe style="width: 100%" highlight-current-row
          v-if="ruleForm.taskCatalogue == 2" @current-change="handleCurrentChange">
          <el-table-column label="封面" align="center" width="130">
            <template slot-scope="scope">
              <el-image style="width: 100px; height: 100px"
                :src="scope.row.bookImgUrl ? scope.row.serverHttp + scope.row.bookImgUrl : ''" fit="cover">
                <div slot="error" class="image-err">暂无封面</div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="bookName" label="名称" align="center"></el-table-column>
          <el-table-column prop="bookGradesName" label="适合年级" align="center"></el-table-column>
          <el-table-column prop="bookStarNumber" label="阅读分级（星星值）" align="center"></el-table-column>
          <el-table-column prop="bookAuthor" label="作者" align="center"> </el-table-column>
          <el-table-column prop="publishingName" label="出版社" align="center"></el-table-column>
          <el-table-column prop="bookCode" label="编号" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="50">
            <template slot-scope="scope">
              <el-radio v-model="bookSelectedId" :label="scope.row.id" @input="bookChange">{{ '' }}</el-radio>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="pageNum" @prev-click="gai1" @next-click="gai1" @current-change="gai1"
          :hide-on-single-page="true" background :page-size="5" layout="total,prev, pager, next"
          style="margin-top: 15px" :total="total1"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bookClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitBook" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :append-to-body="true" title="选择图书系列" :visible.sync="dialogVisible3" width="60%" style="text-align: left"
      :before-close="billClose">
      <div element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loading="loading1">
        <!-- <el-form label-width="80px">
          <el-form-item label="适合年级:">
            <el-button
              type="text"
              @click="
                pageNum2 = 1
                gradeId = ''
                taskQueryBillList()
              "
              :class="gradeId == '' ? '' : 'yanse'"
              >全部</el-button
            >
            <el-button
              type="text"
              @click="
                pageNum2 = 1
                gradeId = item.gradeId
                taskQueryBillList()
              "
              :class="item.gradeId == gradeId ? '' : 'yanse'"
              v-for="item in gradeList"
              :key="item.gradeId"
              >{{ item.name }}</el-button
            >
          </el-form-item>
        </el-form> -->
        <div>
          <el-input size="small" style="width: 250px" v-model="queryBillName" placeholder="请输入系列名称" @keyup.enter.native="
            pageNum2 = 1
          taskQueryBillList()
            "></el-input>
          <el-button type="primary" @click="
            pageNum2 = 1
          taskQueryBillList()
            " size="small">搜索</el-button>
        </div>
        <div>
          <el-button type="text" :class="!isSchool ? '' : 'huihse'" @click="switchBills(false)">平台书库</el-button>
          <el-button type="text" :class="isSchool ? '' : 'huihse'" @click="switchBills(true)">校本书库</el-button>
        </div>
        <el-table :data="billList" ref="singleTable2" border stripe style="width: 100%" highlight-current-row
          v-if="ruleForm.taskCatalogue == 1" @current-change="handleCurrentChange2">
          <el-table-column label="封面" align="center" width="130">
            <template slot-scope="scope">
              <el-image style="width: 100px; height: 100px"
                :src="scope.row.imgUrl ? scope.row.serverHttp + scope.row.imgUrl : ''" fit="cover">
                <div slot="error" class="image-err">暂无封面</div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="billName" label="名称" align="center"></el-table-column>
          <el-table-column prop="billGradesName" label="适合年级" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="50">
            <template slot-scope="scope">
              <el-radio v-model="billSelectedId" :label="scope.row.id" @input="billChange">{{ '' }}</el-radio>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="pageNum2" @prev-click="gai2" @next-click="gai2" @current-change="gai2"
          :hide-on-single-page="true" background :page-size="5" layout="total,prev, pager, next"
          style="margin-top: 15px" :total="total2"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="billClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitBill" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :append-to-body="true" title="任务详情" :visible.sync="dialogVisible4" width="60%" style="text-align: left"
      :before-close="detailClose">
      <el-descriptions v-if="detail" :column="1">
        <el-descriptions-item label="任务名称">{{ detail.taskName }}</el-descriptions-item>
        <el-descriptions-item label="任务类型">{{ detail.taskType == 1 ? '必读' : '推荐' }}</el-descriptions-item>
        <el-descriptions-item label="任务范围">
          <div>
            <span v-for="(item, index) in detail.readTaskScopeList" :key="item.id">{{ item.gradeName }}{{ item.className
              }}{{ index != detail.readTaskScopeList.length - 1 ? '、' : '' }}</span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="任务进度(人数)在读/已读/已测">{{ detail.readingNumber }}/{{ detail.completeNumber }}/{{
          detail.paperNumber }}</el-descriptions-item>

        <el-descriptions-item label="发布人">{{ detail.creatorName }}</el-descriptions-item>
        <el-descriptions-item label="发布状态">{{ detail.publishStatus == 1 ? '已发布' : '未发布' }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ detail.updateTime }}</el-descriptions-item>
        <el-descriptions-item :label="detail.taskCatalogue == 1 ? '书单详情' : '图书详情'">
          <el-table :data="detail.taskCatalogue == 1 ? detail.readBillList : detail.readBooksList" border stripe
            style="width: 100%" highlight-current-row>
            <el-table-column label="封面" align="center" width="130" v-if="detail.taskCatalogue == 1">
              <template slot-scope="scope">
                <el-image style="width: 100px; height: 100px"
                  :src="scope.row.imgUrl ? scope.row.serverHttp + scope.row.imgUrl : ''" fit="cover">
                  <div slot="error" class="image-err">暂无封面</div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="billName" label="名称" align="center"
              v-if="detail.taskCatalogue == 1"></el-table-column>
            <el-table-column prop="billGradesName" label="适合年级" align="center"
              v-if="detail.taskCatalogue == 1"></el-table-column>
            <el-table-column label="封面" align="center" width="130" v-if="detail.taskCatalogue == 2">
              <template slot-scope="scope">
                <el-image style="width: 100px; height: 100px"
                  :src="scope.row.bookImgUrl ? scope.row.serverHttp + scope.row.bookImgUrl : ''" fit="cover">
                  <div slot="error" class="image-err">暂无封面</div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="bookName" label="名称" align="center"
              v-if="detail.taskCatalogue == 2"></el-table-column>
            <el-table-column prop="bookGradesName" label="适合年级" align="center"
              v-if="detail.taskCatalogue == 2"></el-table-column>
            <el-table-column prop="bookStarNumber" label="阅读分级（星星值）" align="center"
              v-if="detail.taskCatalogue == 2"></el-table-column>
            <el-table-column prop="bookAuthor" label="作者" align="center" v-if="detail.taskCatalogue == 2">
            </el-table-column>
            <el-table-column prop="publishingName" label="出版社" align="center"
              v-if="detail.taskCatalogue == 2"></el-table-column>
            <el-table-column prop="bookCode" label="编号" align="center"
              v-if="detail.taskCatalogue == 2"></el-table-column>
          </el-table>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <div v-if="shju" style="">
      <el-page-header style="margin-bottom: 20px" @back="shju = false"></el-page-header>
      <el-tabs v-model="activeName">
        <el-tab-pane :label="item.gradeName + item.className" :name="item.classId" v-for="(item, index) in classlist"
          :key="index"></el-tab-pane>
      </el-tabs>
      <el-table key="detailDataTable" :data="detailDataTable" stripe border style="width: 100%; margin-top: 15px">
        <el-table-column type="index" label="序号" align="center"> </el-table-column>
        <el-table-column prop="studentName" label="学生姓名" align="center"> </el-table-column>
        <el-table-column prop="readCount" label="在读" align="center">
          <template slot-scope="scope">
            {{ scope.row.readCount}}/{{ scope.row.bookCount }}
          </template>
        </el-table-column>
        <el-table-column prop="readingNumber" label="已读" align="center">
          <template slot-scope="scope">
            {{ scope.row.readingNumber}}/{{ scope.row.bookCount }}
          </template>
        </el-table-column>
        <el-table-column prop="homeworkCount" label="作业" align="center">
          <template slot-scope="scope">
            {{ scope.row.homeworkCount}}/{{ scope.row.homeworkNumber }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="阅读开始时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.startTime ? scope.row.startTime : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="endTime" label="阅读完成时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.endTime ? scope.row.endTime : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="starValue" label="获得星星值" align="center"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as homeApi from '@/api/home'
import { yearhistorylist, queryReadTaskList, queryStudentList } from '@/api/home'
var validateScope = (rule, value, callback) => {
  var flag = true
  if (value.length == 0) {
    flag = false
  }
  if (flag) {
    callback()
  } else {
    callback(new Error('选项不能为空'))
  }
}
export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      shju: false,
      defaultProps: {
        children: 'classesList',
        label: 'name'
      },
      schoolId: '',
      options: [],
      value: '',
      tableData: [],
      loading: false,
      loading1: false,
      page: 1,
      total: 0,
      status: '',
      type: '',
      input: '',
      activeName: 0,
      ruleForm: {
        id: '',
        taskName: '',
        taskType: '',
        billIdList: [],
        bookIdList: [],
        classesIdList: [],
        taskCatalogue: 1
      },
      rules: {
        taskName: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        taskType: [{ required: true, message: '请选择任务类型', trigger: 'change' }],
        classesIdList: [{ required: true, message: '请选择任务范围', validator: validateScope }]
      },
      checkedList: [],
      gradeList: [],
      taskTypeList: [],
      taskCatalogueList: [],
      queryBookName: '',
      queryBillName: '',
      bookList: [],
      billList: [],
      bookSelectedId: '',
      billSelectedId: '',
      bookSelected: null,
      billSelected: null,
      pageNum: 1,
      pageNum2: 1,
      total1: 0,
      total2: 0,
      dialogVisible4: false,
      detail: null,
      isSchool: false,
      classifyId: [],
      bookLevel: '',
      wanchenglist: {},
      specialId: '',
      gradeId: '',
      bookLevelList: [],
      options1: [],
      specialColumnList: [],
      queryTime: [],
      detailDataTable: [],
      detailDataTotal: 0,
      classlist: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  watch: {
    queryTime() {
      this.queryReadTaskList()
    },
    activeName() {
      let that = this
      that.loading = true
      let params = {
        taskId: this.wanchenglist.id,
        classId: this.activeName,
        pageNum: 1,
        pageSize: 1000,
      }
      queryStudentList(params)
        .then((res) => {
          that.loading = false
          that.detailDataTable = res.data.data.dataList
          that.detailDataTotal = res.data.data.totalCount
        })
        .catch(() => {
          that.loading = false
        })
    }
  },
  methods: {
    getTreeReadClassify() {
      let that = this
      let params = {
        schoolId: -1
      }
      homeApi
        .getTreeReadClassify(params)
        .then((res) => {
          res.data.data = that.xunahj(res.data.data)
          that.options1 = res.data.data
        })
        .catch(() => { })
    },
    xunahj(s) {
      s.forEach((item) => {
        item.value = item.id
        item.label = item.classifyName
        if (item.chilrenList && item.chilrenList.length > 0) {
          item.children = item.chilrenList
          this.xunahj(item.children)
        }
      })
      return s
    },
    dictcode() {
      let that = this
      homeApi
        .dictcode({
          code: 'special_column'
        })
        .then((res) => {
          that.specialColumnList = res.data.data
        })
    },
    dictcode1() {
      let that = this
      homeApi
        .dictcode({
          code: 'book_level'
        })
        .then((res) => {
          that.bookLevelList = res.data.data
        })
    },
    getDetail(item) {
      homeApi.getTaskDetail({ id: item.id }).then((res) => {
        if (res.data.code == 0) {
          this.dialogVisible4 = true
          this.detail = res.data.data
          this.detail.readingNumber = item.readingNumber
          this.detail.completeNumber = item.completeNumber
          this.detail.paperNumber = item.paperNumber
        }
      })
    },
    wancheng(s) {
      this.shju = true
      let classId = s.readTaskScopeList[0].classId
      this.activeName = classId
      this.classlist = s.readTaskScopeList
      this.wanchenglist = s
      let that = this
      that.loading = true
      let params = {
        taskId: s.id,
        classId: classId,
        pageNum: 1,
        pageSize: 1000,
      }
      queryStudentList(params)
        .then((res) => {
          that.loading = false
          that.detailDataTable = res.data.data.dataList
          that.detailDataTotal = res.data.data.totalCount
        })
        .catch(() => {
          that.loading = false
        })
    },
    detailClose(done) {
      this.detail = null
      done()
    },
    switchBooks(isSchool) {
      this.pageNum = 1
      this.bookSelected = null
      this.bookSelectedId = ''
      this.$refs.singleTable.setCurrentRow()
      this.isSchool = isSchool
      this.taskQueryList()
    },
    switchBills(isSchool) {
      this.pageNum2 = 1
      this.billSelected = null
      this.billSelectedId = ''
      this.$refs.singleTable2.setCurrentRow()
      this.isSchool = isSchool
      this.taskQueryBillList()
    },
    edit(item) {
      homeApi.getTaskDetail({ id: item.id }).then((res) => {
        if (res.data.code == 0) {
          this.dialogVisible = true
          this.ruleForm.id = res.data.data.id
          this.ruleForm.taskName = res.data.data.taskName
          this.ruleForm.taskType = res.data.data.taskType
          this.ruleForm.taskCatalogue = res.data.data.taskCatalogue
          this.ruleForm.classesIdList = res.data.data.readTaskScopeList
          this.ruleForm.classesIdList.map((cl) => {
            cl.name = cl.gradeName + cl.className
          })
          if (this.ruleForm.taskCatalogue == 1) {
            this.ruleForm.billIdList = res.data.data.readBillList
          } else {
            this.ruleForm.bookIdList = res.data.data.readBooksList
          }
        }
      })
    },
    publish(item) {
      this.$confirm('发布后将不可撤销及编辑, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          homeApi.publishTask({ taskId: item.id }).then((res) => {
            if (res.data.code == 0) {
              this.queryReadTaskList()
              this.$message({
                message: '发布成功',
                type: 'success'
              })
            }
            this.loading = false
          })
        })
        .catch(() => {
          this.loading = false
        })
    },
    deleteItem(item) {
      this.$confirm('是否确定删除该任务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          homeApi.delTask({ taskId: item.id }).then((res) => {
            if (res.data.code == 0) {
              this.queryReadTaskList()
              this.$message({
                message: '删除成功',
                type: 'success'
              })
            }
          })
        })
        .catch(() => { })
    },
    addClose(done) {
      this.resetForm()
      done()
    },
    resetForm() {
      this.ruleForm = {
        id: '',
        taskName: '',
        taskType: '',
        billIdList: [],
        bookIdList: [],
        classesIdList: [],
        taskCatalogue: 1
      }
      this.bookSelectedId = ''
      this.billSelectedId = ''
      this.bookSelected = null
      this.billSelected = null
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate()
      })
    },
    submitRuleForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.ruleForm.taskCatalogue === 1) {
            if (this.ruleForm.billIdList.length == 0) {
              this.$message.error('请选择图书系列')
              return
            }
          } else if (this.ruleForm.taskCatalogue === 2) {
            if (this.ruleForm.bookIdList.length == 0) {
              this.$message.error('请选择书籍')
              return
            }
          }
          let that = this
          let params = JSON.parse(JSON.stringify(that.ruleForm))
          if (params.id === '') {
            delete params.id
          }
          let classes = []
          params.classesIdList.map((item) => {
            classes.push(item.classId)
          })
          params.classesIdList = classes
          if (params.taskCatalogue === 1) {
            delete params.bookIdList
            let bills = []
            params.billIdList.map((item) => {
              bills.push(item.id)
            })
            params.billIdList = bills
          } else if (params.taskCatalogue === 2) {
            delete params.billIdList
            let books = []
            params.bookIdList.map((item) => {
              books.push(item.id)
            })
            params.bookIdList = books
          }
          this.loading = true
          homeApi
            .saveReadTask(params)
            .then((res) => {
              if (res.data.code == 0) {
                this.dialogVisible = false
                this.resetForm()
                this.queryReadTaskList()
                this.$message({
                  message: '提交成功',
                  type: 'success'
                })
              }
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    bookClose(done) {
      this.isSchool = false
      this.bookSelectedId = ''
      this.bookSelected = null
      if (typeof done == 'function') {
        done()
      } else {
        this.dialogVisible2 = false
      }
    },
    bookChange(val) {
      let index = this.bookList.findIndex((item) => {
        return item.id === val
      })
      if (index != -1) {
        this.bookSelected = this.bookList[index]
        this.$refs.singleTable.setCurrentRow(this.bookList[index])
      }
    },
    billClose(done) {
      this.isSchool = false
      this.billSelectedId = ''
      this.billkSelected = null
      this.pageNum2 = 1
      if (typeof done == 'function') {
        done()
      } else {
        this.dialogVisible3 = false
      }
    },
    billChange(val) {
      let index = this.billList.findIndex((item) => {
        return item.id === val
      })
      if (index != -1) {
        this.billSelected = this.billList[index]
        this.$refs.singleTable2.setCurrentRow(this.billList[index])
      }
    },
    handleCurrentChange(val) {
      this.bookSelectedId = val.id
      this.bookSelected = val
    },
    handleCurrentChange2(val) {
      this.billSelectedId = val.id
      this.billSelected = val
    },
    submitBook() {
      if (this.bookSelected) {
        this.ruleForm.bookIdList = [this.bookSelected]
        this.dialogVisible2 = false
      } else {
        this.$message.error('请选择图书！')
      }
    },
    submitBill() {
      if (this.billSelected) {
        this.ruleForm.billIdList = [this.billSelected]
        this.dialogVisible3 = false
      } else {
        this.$message.error('请选择图书系列！')
      }
    },
    selectBook() {
      this.taskQueryList()
    },
    selectBill() {
      this.taskQueryBillList()
    },
    taskQueryBillList() {
      this.loading1 = true
      this.dialogVisible3 = true
      let params = {
        schoolId: this.isSchool ? this.schoolId : -1,
        billName: this.queryBillName,
        pageNum: this.pageNum2,
        pageSize: 5,
        gradeId: this.gradeId
      }
      homeApi
        .taskQueryBillList(params)
        .then((res) => {
          this.loading1 = false
          this.billList = res.data.data.dataList
          this.total2 = res.data.data.totalCount
          if (this.ruleForm.billIdList.length > 0) {
            this.billList.map((item) => {
              if (this.ruleForm.billIdList[0].id == item.id) {
                this.billSelected = item
                this.billSelectedId = item.id
                this.$refs.singleTable2.setCurrentRow(item)
              }
            })
          }
        })
        .catch((error) => {
          this.loading1 = false
          console.log(error)
        })
    },
    taskQueryList() {
      this.loading1 = true
      this.dialogVisible2 = true
      let params = {
        schoolId: this.isSchool ? this.schoolId : -1,
        bookName: this.queryBookName,
        pageNum: this.pageNum,
        pageSize: 5,
        classifyId: this.classifyId.length > 0 ? this.classifyId[this.classifyId.length - 1].toString() : '',
        specialColumn: this.specialId,
        bookLevel: this.bookLevel,
        bookGrades: this.gradeId
      }
      homeApi
        .taskQueryList(params)
        .then((res) => {
          this.loading1 = false
          this.bookList = res.data.data.dataList
          this.total1 = res.data.data.totalCount
          if (this.ruleForm.bookIdList.length > 0) {
            this.bookList.map((item) => {
              if (this.ruleForm.bookIdList[0].id == item.id) {
                this.bookSelected = item
                this.bookSelectedId = item.id
                this.$refs.singleTable.setCurrentRow(item)
              }
            })
          }
        })
        .catch((error) => {
          this.loading1 = false
          console.log(error)
        })
    },
    selectTree() {
      this.dialogVisible1 = true
      this.checkedList = JSON.parse(JSON.stringify(this.ruleForm.classesIdList))
      this.$refs.tree.setCheckedKeys([])
      this.$nextTick(() => {
        this.checkedList.map((item) => {
          this.$refs.tree.setChecked(item, true)
        })
      })
    },
    handleCheckChange(data, checked) {
      this.checkedList = []
      checked.checkedNodes.map((item) => {
        if (item.id) {
          this.checkedList.push(item)
        }
      })
    },
    submitGrade() {
      this.dialogVisible1 = false
      this.ruleForm.classesIdList = JSON.parse(JSON.stringify(this.checkedList))
    },
    gradegradelist() {
      let params = {
        schoolId: this.schoolId
      }
      homeApi
        .gradegradelist(params)
        .then((res) => {
          this.gradeList = res.data.data
          this.gradeList.map((grade) => {
            grade.classesList.map((classes) => {
              classes.classId = classes.id
              classes.name = classes.gradeName + classes.title
            })
          })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getTaskCatalogue() {
      let that = this
      let params = {
        code: 'read_task_catalogue'
      }
      homeApi
        .dictcode(params)
        .then((res) => {
          that.taskCatalogueList = res.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getTaskType() {
      let that = this
      let params = {
        code: 'read_task_type'
      }
      homeApi
        .dictcode(params)
        .then((res) => {
          that.taskTypeList = res.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    list() {
      let that = this
      yearhistorylist()
        .then((res) => {
          that.options = res.data.data
          for (var i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].isCurrent == 1) {
              let start = res.data.data[i].startTime.split(' ')[0]
              let end = res.data.data[i].endTime.split(' ')[0]
              that.queryTime = [start, end]
              // that.value = res.data.data[i].id
            }
          }
        })
        .catch(() => {
          that.loading = false
        })
    },
    sou() {
      this.page = 1
      this.queryReadTaskList()
    },
    queryReadTaskList() {
      let that = this
      that.loading = true
      let params = {
        pageNum: this.page,
        pageSize: 10,
        // termId: this.value,
        startTime: this.queryTime[0],
        endTime: this.queryTime[1],
        taskName: this.input,
        schoolId: this.schoolId,
        publishStatus: this.status,
        taskType: this.type
      }
      queryReadTaskList(params)
        .then((res) => {
          that.loading = false
          that.tableData = res.data.data.dataList
          that.total = res.data.data.totalCount
        })
        .catch(() => {
          that.loading = false
        })
    },
    gai1(s) {
      this.pageNum = s
      this.bookSelected = null
      this.bookSelectedId = ''
      this.$refs.singleTable.setCurrentRow()
      this.taskQueryList()
    },
    gai2(s) {
      this.pageNum2 = s
      this.billSelected = null
      this.billSelectedId = ''
      this.$refs.singleTable2.setCurrentRow()
      this.taskQueryBillList()
    },
    gai(s) {
      this.page = s
      this.queryReadTaskList()
    }
  },
  mounted() {
    let info = JSON.parse(localStorage.getItem('info'))
    this.schoolId = info.schoolId
    this.gradegradelist()
    this.getTaskCatalogue()
    this.getTaskType()
    this.list()
    this.dictcode()
    this.dictcode1()
    this.getTreeReadClassify()
  }
}
</script>

<style scoped>
/deep/.el-form-item {
  margin-bottom: 5px;
}

.spb {
  display: flex;
  justify-content: space-between;
}

.el-table .el-button {
  padding: 0px;
}

.yanse {
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/components/readTask/index.vue